import { resolveLink } from '@/utils/resolvers';
import { PortalMenuItem } from './PortalNavigation.interfaces';

export const navigationItemsResolver = ({
  rawVal: groups = [],
  page,
  pageModels,
}: any): PortalMenuItem[] => {
  const getResolveLink = (rawVal: any) => resolveLink({ rawVal, page, pageModels });
  let navigationItems: PortalMenuItem[] = [];

  groups.forEach((group: any) => {
    const {
      groupTitle: { horizontalDivider = false, link },
      menuItem = [],
    } = group;
    navigationItems = [
      ...navigationItems,
      {
        link: getResolveLink(link),
        navigationItems:
          menuItem.length > 0
            ? menuItem.map((menuItemLink: any) => ({
                link: getResolveLink(menuItemLink),
              }))
            : undefined,
        isDivider: false,
      },
    ];
    if (horizontalDivider) {
      navigationItems = [...navigationItems, { isDivider: true }];
    }
  });
  return navigationItems;
};
